import { types, applySnapshot} from "mobx-state-tree";
import { Framework } from "@flint/framework";

const AddGenusSpecialityModel = types
  .model("AddGenusSpecialityModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch(event) {
      Framework.sendEvent("Add_GenusSpeciality", { event });
    },
    set(response) {
      let data;
      if (response.data.response === "Record Exists") {
        data =
          "The record you are trying to add already exists.";
      } else if (response.data.response === "SUCCESS") {
        data = "The record has been added successfully. Please check HOME PAGE after some time.";
      } else {
        data = response.data.response;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res: "Oops...Something went wrong. Please try again!",
      });
    },
  }));

export default AddGenusSpecialityModel;
